import * as R from 'ramda'

import * as actionTypes from 'store/actionTypes/me'

export const setMe = R.assoc('me', R.__, { type: actionTypes.SET_ME })
export const logoutMe = () => ({ type: actionTypes.LOGOUT_ME })
export const setContext = R.assoc('context', R.__, { type: actionTypes.SET_CONTEXT })
